import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const FireAndBurglaryFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1. How does the location of my property affect the premiums for fire and burglary insurance?",
      answer: (
        <>
          The location of your property plays an important role in determining the premiums for fire and burglary insurance. Insurance companies assess the risk associated with the location based on several factors:
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>1.Crime Rate:</span><span style={{ color: "black"}}> Properties located in areas with higher crime rates, especially burglary or vandalism, typically face higher premiums due to increased risk of theft-related claims.</span>
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>2.Fire Risk: </span><span style={{ color: "black"}}>Properties situated in regions prone to wildfires or with inadequate fire protection infrastructure may have higher premiums to account for the elevated risk of fire damage.</span>
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>3.Closeness to Emergency Services:</span><span style={{ color: "black"}}> Access to fire stations and emergency response services can influence premiums. Properties closer to these services may benefit from lower premiums due to quicker response times in case of emergencies.</span>
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>4.Natural Disaster Risk: </span> <span style={{ color: "black"}}>prone to natural disasters such as floods, earthquakes, or hurricanes may have higher premiums or require separate insurance policies to cover these risks.</span>
        </>
      )
    },
    {
      question: "Q2. Does the policy include coverage for damages caused by smoke or water used to extinguish a fire?",
      answer: (
        <>
        <span style={{ color: "#F37435", fontWeight: "700" }} >Yes, </span>typically, fire insurance policies include coverage for damages caused by smoke or water used to extinguish a fire. This coverage helps in repairing or replacing property that has been damaged as a result of smoke or water used by firefighters during the firefighting process. It's important to review your specific policy details to understand the extent of coverage provided for smoke and water damage in the event of a fire.
       </>
      )
    },
    {
      question: "Q3. Does the insurance policy require specific security measures to be in place for coverage to apply?",
      answer:(
        <>
       Some insurance policies <span style={{ color: "#F37435", fontWeight: "700" }} >may require certain security measures</span> for coverage to be effective. This can include installing burglar alarms, secure locks on doors and windows, and sometimes security cameras. These measures help reduce the risk of theft or burglary and are often outlined in your policy documentation. Ensuring these measures are in place and maintained can help ensure your coverage remains valid in case of a claim related to theft or burglary.
      </>
      )
      },

      {
        question: "Q4. How does filing a claim for combined fire and burglary damage work if both occur at the same time?",
        answer:(
          <>
        If your property suffers from both fire and burglary damage at the same time, you would typically <span style={{ color: "#F37435", fontWeight: "700" }} >file one insurance claim covering</span> both incidents. You'll need to notify your insurance provider promptly, provide documentation like police reports and damage assessments, and your insurer will evaluate the combined damages to determine coverage and process your claim accordingly.
        </>
        )
        },
    {
      question: "Q5. What factors determine the premium for fire and burglary insurance?",
      answer: (
        <>
        The cost of fire and burglary insurance premiums is influenced by factors such as the <span style={{ color: "#F37435", fontWeight: "700" }} >property's location, its value, security measures in place (like alarms and locks), your claims history, chosen deductible amount, building materials, and whether the property is owner-occupied or rented out. These factors help insurers assess the risk associated with insuring your property, impacting the price you pay for coverage.</span>
        </>
      )
      
    
    },
    {
      question: "Q6. Can you purchase fire and burglary insurance if you live in a rented house?",
      answer: (
        <>
          <span style={{ color: "#F37435", fontWeight: "700" }} >Yes, </span>you can buy fire and burglary insurance even if you live in a rented house. This type of insurance, often called renter's insurance or tenant's insurance, protects your personal belongings and provides liability coverage while you're renting. It covers losses from events like theft, fire, or vandalism, ensuring that your possessions are financially protected even if the property itself is owned by someone else.
        </>
      )
      
    },
    {
      question: "Q7. What is reinstatement value?",
      answer: (
      
       <>
       Reinstatement value is the amount of money your insurance will pay to replace or repair your damaged property with new items that are similar in kind and quality. This coverage ensures you can<span style={{ color: "#F37435", fontWeight: "700" }} >restore your property</span> to its original condition without subtracting for depreciation, so you get back what you need to rebuild or replace what was lost.
        </>

      )
      
    },
    {
      question: "Q8. How often should I review and update my fire and burglary insurance policy?",
      answer: (
        <>
          Check your insurance policy every year or <span style={{ color: "#F37435", fontWeight: "700" }} >when anything big changes</span> with your property or life. This could be renovations, adding new things, or changes in how much your property is worth. Keeping your policy up-to-date makes sure it covers what you need and helps avoid any surprises if something happens.
        </>
      )
        
    },
    {
      question: "Q9. Does fire and burglary insurance cover landscaping or outdoor structures?",
      answer: 
      (
        <>
         Fire and burglary insurance generally <span style={{ color: "#F37435", fontWeight: "700" }} >does not cover </span>landscaping or outdoor structures like sheds, fences, or gardens. This type of insurance typically focuses on protecting the main structure of the building and personal property inside it from fire, theft, vandalism, and related perils.

        </>
      )
    },
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default FireAndBurglaryFAQ;